import { Switch } from "@headlessui/react";
import { getBackgroundColorClass } from "../../ui";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ShortToggle({value, onChange, color = 'primary'}) {
  return (
    <Switch
      defaultChecked={!!value}
      onChange={() => onChange && onChange(!value)}
      className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full border-transparent bg-transparent"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute h-full w-full rounded-md bg-white"
      />
      <span
        aria-hidden="true"
        className={classNames(
          !!value ? getBackgroundColorClass(color) : "bg-gray-200",
          "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
        )}
      />
      <span
        aria-hidden="true"
        className={classNames(
          !!value ? "translate-x-5" : "translate-x-0",
          "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
        )}
      />
    </Switch>
  );
}
